import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import SourceIcon from '../theme/icons/source.svg';

export default class SourceEditing extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'SourceEditing';
	}

	init() {
		const editor = this.editor;
		const t = editor.t;

		const config = editor.config.get( 'source' );
		const edit = config && config.edit;
		if ( typeof edit !== 'function' ) {
			throw new Error(
				'Add an \'edit\' function for the source configuration'
			);
		}

		// Add the `imageBrowser` button to feature components.
		editor.ui.componentFactory.add( 'sourceEditing', locale => {
			const view = new ButtonView( locale );

			view.set( {
				label: t( 'Edit Source' ),
				icon: SourceIcon,
				tooltip: true
			} );

			// Execute the command.
			this.listenTo( view, 'execute', async () => {
				// Get the current source.
				const html = editor.data.get();

				// Fire the editor.
				let result = edit( html );
				if ( result instanceof Promise ) {
					result = await result;
				}

				// Set the result.
				if ( result && typeof result === 'string' ) {
					editor.data.set( result, { batchType: 'default' } );
				}
			} );

			return view;
		} );
	}
}
